// @ts-nocheck1
'use client';
// import axios from 'axios';
import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { Toast } from '../../../src/services/toast';
// import DatePicker from "react-datepicker";
// import 'react-datepicker/dist/react-datepicker.css';
import * as tradeBroadcastAction from '@/redux/actions/TradeBoardCast';
import { PencilSquare } from 'react-bootstrap-icons';
import SimpleReactValidator from 'simple-react-validator';
import * as bondsAction from '../../redux/actions/bonds';
import * as portfolioAction from '../../redux/actions/portfolios';
import { EXIST_LOCAL_STORAGE } from '../../services/constants';
import { getCookie, getStorage } from '../../services/helperFunctions';
// import * as portfoliosAction from "../../redux/action/portfolios";
import { useRouter } from 'next/navigation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LazyLoading from '../LazyLoading/LazyLoading';

interface BondPosition {
    show: boolean;
    onclose: () => void;
    bondId: any;
    getBondPositionBriefDetails?: any;
    createBondsPosition?: any;
    getBondsPortfolioList?: any;
    getBondsPriceByDate?: any;
    setShowPosition?: any;
    addPortfolioByPosition?: any;
    copyTrade?: any;
    selectedAction?: any;
    getTradeBoardCastRightBar?: any;
    getPosition?: any;
    selectedPortfolioId?: number;
}

interface BondPositionValues {
    bond_id: number;
    name: string;
    isin: string;
    bid_price: number;
    ask_price: number;
    pricing_date: string;
    bond_name?: string; // Added bond_name property
}

interface BondPriceByDate {
    buy_price: any;
    sell_price: any;
    pricing_date: any;
}

interface PortfoliosList {
    user_name: any;
    user_id: any;
    portfolio_id: any;
    portfolio_id_name: any;
    portfolio_name: string;
}

const BondPosition: React.FC<BondPosition> = ({
    show,
    addPortfolioByPosition,
    onclose,
    getBondPositionBriefDetails,
    createBondsPosition,
    getBondsPortfolioList,
    getBondsPriceByDate,
    bondId,
    copyTrade,
    selectedAction,
    getTradeBoardCastRightBar,
    getPosition,
    selectedPortfolioId,
}) => {
    const router = useRouter();
    const userId = getCookie(EXIST_LOCAL_STORAGE.USER_ID);
    const unitsRef = useRef<HTMLInputElement>(null);
    const [bondPositionData, setBondPositionData] = useState<BondPositionValues[]>([]);
    const [showModal, setShowModal] = useState(true);
    const [selectPortfolios, setSelectPortfolios] = useState<PortfoliosList[]>([]);
    const [unit, setUnit] = useState<number | null>(null);
    const [bondPriceByDate, setbondPriceByDate] = useState<BondPriceByDate>();
    const [buyPrice, setBuyPrice] = useState(-1);
    const [bidPrice, setBidPrice] = useState(0);
    const [askPrice, setAskPrice] = useState(0);
    const [sellPrice, setSellPrice] = useState(-1);
    const [portfolioId, setPortfolioId] = useState(selectedPortfolioId);
    const todayDate = new Date().toISOString().split('T')[0];
    const [positionDate, setPositionDate] = useState<string | null>(null);
    const [value, setValue] = useState(selectedAction ?? 'buyPrice');
    //const [valuePrice, setValuesprice] = useState();
    const [totalUnits, setTotalUnits] = useState<number | null>(null);
    const [portfolioIdBond, setPortfolioIdBond] = useState();
    const [valuesBidOrAsk, setValuesBidOrAsk] = useState(selectedAction ?? 'buyPrice');
    //const [isTyping, setIsTyping] = useState(true);
    const simpleValidator = useRef(new SimpleReactValidator({ className: 'text-danger' }));
    const [, forceUpdate] = useState(0);
    const [isFormSubmit, setIsFormSubmit] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [loading, setLoading] = useState(true);
    const handleCloseDialog = () => {
        // setBuyPrice(0);
        setBidPrice(0);
        setSellPrice(0);
        setAskPrice(0);
        setValue('buyPrice');
        handleCancelButton();
        setShowDialog(false);
    };
    const fetchBondData = async () => {
        try {
            setLoading(true);
            let UserId = getStorage(EXIST_LOCAL_STORAGE.USER_ID);
            let body = {
                params: {
                    user_id: UserId,
                    portfolio_id: portfolioId ? portfolioId : portfolioIdBond,
                    isin: bondId,
                },
            };
            getBondPositionBriefDetails(body).then((response: any) => {
                if (response.code !== 200) {
                    Toast({
                        type: 'error',
                        message: response.message,
                        title: response.status,
                    });
                    // setBuyPrice(0);
                    setBidPrice(0);
                    setSellPrice(0);
                    setAskPrice(0);
                    setValue(selectedAction ?? 'buyPrice');
                    handleCancelButton();
                    setShowDialog(false);
                    //   simpleValidator.current.hideMessages();
                    return;
                }
                console.log('response', response?.data);
                let data = response?.data[0] ?? {};
                console.log('dataaaaaaa', data);
                setLoading(false);
                setPositionDate(data?.pricing_date?.split('T')[0]);
                setTotalUnits(data?.total_units);

                setBondPositionData(response?.data);
                setBuyPrice(data?.ask_price);
                setBidPrice((prev) => (data?.bid_price ? data?.bid_price : prev));
                setSellPrice(data?.bid_price);
                setAskPrice((prev) => (data?.ask_price ? data?.ask_price : prev));
                if (data?.total_units === null) {
                    // setValue('buyPrice')
                } else if (data?.total_units > 0) {
                    // setValue(selectedAction ?? value)
                }
            });
        } catch (error) {
            console.error('Error fetching bond data:', error);
        }
    };
    useEffect(() => {
        if (!!portfolioIdBond && show) {
            unitsRef.current?.focus();
            fetchBondData();
        }
    }, [portfolioIdBond, show, portfolioId]);

    const handleCancelButton = () => {
        setShowModal(false);
        setPortfolioId(selectedPortfolioId);
        setUnit(null);
        setValue(selectedAction ?? 'buyPrice');
        setBuyPrice(-1);
        setBidPrice(0);
        setSellPrice(-1);
        setAskPrice(0);
        setBidPriceinputShow(false);
        setSellPriceinputShow(false);
        setUnitError('');
        setBondPositionData([]);
        onclose();
        simpleValidator.current.hideMessages();
    };
    console.log('askPrice', askPrice);
    const UserId = getStorage(EXIST_LOCAL_STORAGE.USER_ID);
    const fetchTradeBroadcastData = async () => {
        if (UserId) {
            try {
                const body = {
                    params: {
                        user_id: UserId,
                        page_no: 1,
                        per_page: 6,
                    },
                };
                getTradeBoardCastRightBar(body);
            } catch (error) {
                console.error('Error fetching trade boardcast :', error);
            }
        }
    };

    const handleSaveButton = async () => {
        setShowModal(false);
        const validator = simpleValidator.current;
        setIsFormSubmit(true);

        // First hide any existing messages
        validator.hideMessages();

        // Validate all fields
        validator.showMessages();

        // Check validation and price conditions
        const isPriceValid = value === 'buyPrice' ? bidPrice > 0 : askPrice > 0;

        if (!validator.allValid() || !isPriceValid) {
            // Force UI update to show validation messages
            forceUpdate((prev) => prev + 1);
            return; // Stop execution if validation fails
        }

        try {
            // Prepare data
            let data = {
                isin: bondId,
                portfolio_id: parseInt(portfolioId),
                position_type: value === 'buyPrice' ? 1 : 2,
                position_date: positionDate ? positionDate + 'T00:00:00' : bondPositionData + 'T00:00:00',
                cost_price: valuesBidOrAsk === 'buyPrice' ? parseFloat(bidPrice.toString()) : parseFloat(askPrice.toString()),
                units: parseInt((unit ?? 0).toString()),
                user_id: userId,
            };

            // Submit data
            await createBondsPosition(data);

            // Update UI
            fetchTradeBroadcastData();

            if (window.location.pathname === '/portfolio') {
                const body = {
                    params: {
                        user_id: UserId,
                        portfolio_id: portfolioId,
                    },
                };
                await getPosition(body);
            }

            // Reset form
            setBidPrice(0);
            setAskPrice(-1);
            setBidPriceinputShow(false);
            setSellPriceinputShow(false);
            handleCancelButton();
        } catch (error) {
            console.error('Error fetching bond data:', error);
            // Optional: Show error to user
            // setError('Failed to save position');
        }
    };
    const [unitError, setUnitError] = useState('');
    const handleUnitChange = (e: any) => {
        setUnit(parseInt(e.target.value.replace(/[^\w\s]/gi, '')));
        console.log('parseInt(e.target.value)', typeof e.target.value === 'string');

        if (value === 'sellPrice' && !copyTrade) {
            if ((unit ?? 0) > parseFloat(totalUnits?.toString() ?? '0')) {
                setUnitError('');
            } else {
                setUnitError('');
            }
        }
    };

    const handleGetPriceDate = async (e: ChangeEvent<HTMLInputElement>) => {
        const PriceDate = e.target.value;
        setPositionDate(PriceDate);
        if (!PriceDate) {
            console.log('PD----------->', PriceDate);
        }
        try {
            let body = {
                params: {
                    isin: bondId,
                    price_date: PriceDate,
                },
            };
            getBondsPriceByDate(body).then((response: any) => {
                // setbondPriceByDate(response.data);
                // setBuyPrice(response?.data.buy_price);
                setBidPrice(response?.data?.[0]?.bid_price);
                setAskPrice(response?.data?.[0]?.ask_price);
                // setSellPrice(response?.data.sell_price);
            });
        } catch (error) {
            console.error('Error fetching bond data:', error);
        }
    };

    const handleportfolios = async (event: any) => {
        const portfolioId = event.target.value;
        setPortfolioId(portfolioId);
    };

    const GetPortfolioDetails = async () => {
        try {
            let body = {
                params: {
                    user_id: userId,
                },
            };
            getBondsPortfolioList(body).then((response: any) => {
                let data = response?.data;
                console.log('PortfolioList--> ', response);

                setSelectPortfolios(data);
                setPortfolioId(selectedPortfolioId);
                if (response?.code !== 200) {
                    setShowDialog(true);
                    getPosition(false);
                } else {
                    setPortfolioIdBond(response?.data[0]?.portfolio_id);
                    setPortfolioId(response?.data[0]?.portfolio_id);
                    // fetchBondData()
                }
            });
        } catch (error) {
            console.error('Error fetching bondPortfolioList data:', error);
        }
    };
    useEffect(() => {
        if (show) {
            GetPortfolioDetails();
        }
    }, [show, userId]);

    const handleChange = (event: any) => {
        const changeValue = event.target.value;
        setValue(changeValue);
        if (changeValue === 'buyPrice') {
            // setValuesprice(buyPrice);
            setValuesBidOrAsk('buyPrice');
            setSellPriceinputShow(false);
            setSellPriceIcon(false);
            // setAskPrice(askPrice)
        } else {
            // setBuyPrice(buyPrice)
            setSellPriceIcon(true);
            // setBidPrice(buyPrice)
            setBidPriceinputShow(false);
            setValuesBidOrAsk('sellPrice');
            // setValuesprice(sellPrice);
        }
    };
    const handleChangePrice = (e: any) => {
        setBidPrice(e.target.value);
        setValue(e.target.name);
    };
    const handleChangesellPrice = (e: any) => {
        setAskPrice(e.target.value);
    };

    const [bidPriceinputShow, setBidPriceinputShow] = useState(false);
    const [sellPriceinputShow, setSellPriceinputShow] = useState(false);
    const [sellPriceIcon, setSellPriceIcon] = useState(false);
    const handleInputBidPrice = () => {
        setBidPriceinputShow((prev) => !prev);
    };
    const handleInputSellPrice = () => {
        setSellPriceinputShow((prev) => !prev);
    };

    const handleAddPortfolio = () => {
        router.push('/portfolio');
        addPortfolioByPosition(true);
    };

    useEffect(() => {
        setValue(selectedAction ?? 'buyPrice');
        setValuesBidOrAsk(selectedAction ?? 'buyPrice');
    }, [selectedAction]);

    console.log('portfolioId', portfolioId);

    return (
        <div>
            {!showDialog && bondPositionData ? (
                <Modal show={show} onHide={handleCancelButton} dialogClassName="modal-100w modal-sm mt-5 pt-3">
                    {/* {copyTrade && <h4 className="modal-title text-center" style={{ backgroundColor: '#e7ebef'}}>Copy trade</h4>} */}
                    <Modal.Header style={{ backgroundColor: '#e7ebef', height: '85px' }} closeButton>
                        <div className="row" style={{ width: '100%', gap: '10px' }}>
                            {loading && !bondPositionData?.[0]?.bond_name ? (
                                <div>
                                    <LazyLoading Width={100} />{' '}
                                </div>
                            ) : (
                                <h5 className="modal-title text-sm fw-semibold">
                                    <span>{bondPositionData?.[0]?.bond_name}</span>
                                </h5>
                            )}
                            {loading && !bondPositionData?.[0]?.isin ? (
                                <div>
                                    <LazyLoading Width={60} />{' '}
                                </div>
                            ) : (
                                <div className="text-muted text-sm">ISIN: {bondPositionData?.[0]?.isin}</div>
                            )}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row-12">
                            <div className="col-md-6"></div>
                            <Form.Group controlId="dob"></Form.Group>

                            <Form.Group controlId="dob">
                                <Form.Label className="text-sm">Date</Form.Label>
                                <input
                                    className="form-control text-sm"
                                    // value={positionDate}
                                    // name="positionDate"
                                    max={todayDate}
                                    onKeyDown={(e) => e.preventDefault()}
                                    value={positionDate ?? ''}
                                    type="date"
                                    onChange={handleGetPriceDate}
                                />
                                {simpleValidator.current.message('positionDate', positionDate, 'required|string')}
                            </Form.Group>
                        </div>
                        <div className="row pt-2 ps-2">
                            <div className="pricing-toggle">
                                <input
                                    type="radio"
                                    id="pricing-toggle-monthly"
                                    className="text-sm"
                                    name="pricing"
                                    value="buyPrice"
                                    checked={value === 'buyPrice'}
                                    onClick={handleChange}
                                />
                                <label
                                    className={`radio-button text-sm text-success d-flex flex-column ${
                                        value === 'buyPrice' ? 'drop-shadow' : ''
                                    }`}
                                    htmlFor="pricing-toggle-monthly"
                                >
                                    <h6 style={{ fontSize: '13px', display: 'flex', justifyContent: 'space-between' }}>
                                        {' '}
                                        Buy Price <PencilSquare color="#000000" className="edit-bid-price" onClick={handleInputBidPrice} />
                                    </h6>
                                    {bidPriceinputShow ? (
                                        <input
                                            className="border rounded ps-2 text-sm"
                                            autoFocus
                                            style={{ outline: 'none' }}
                                            type="number"
                                            onBlur={() => setBidPriceinputShow(false)}
                                            onChange={handleChangePrice}
                                            value={bidPrice}
                                            name="buyPrice"
                                        />
                                    ) : (
                                        <h6>{bidPrice != null ? (bidPrice === 0 ? 'N/A' : bidPrice) : 'N/A'}</h6>
                                    )}
                                </label>

                                <input
                                    type="radio"
                                    id="pricing-toggle-annually"
                                    name="pricing"
                                    value="sellPrice"
                                    checked={value === 'sellPrice'}
                                    onClick={handleChange}
                                />

                                <label
                                    className={`radio-button text-danger d-flex flex-column ${value === 'sellPrice' ? 'drop-shadow' : ''}`}
                                    htmlFor="pricing-toggle-annually"
                                >
                                    <h6 style={{ fontSize: '13px', display: 'flex', justifyContent: 'space-between' }}>
                                        {' '}
                                        Sell Price{' '}
                                        {sellPriceIcon && (
                                            <PencilSquare color="#000000" className="edit-sell-price" onClick={handleInputSellPrice} />
                                        )}{' '}
                                    </h6>
                                    {sellPriceinputShow ? (
                                        <input
                                            className="border rounded ps-2"
                                            style={{ outline: 'none' }}
                                            autoFocus
                                            onBlur={() => setSellPriceinputShow(false)}
                                            type="number"
                                            onChange={handleChangesellPrice}
                                            value={askPrice}
                                            name="sellPrice"
                                        />
                                    ) : (
                                        <h6>{askPrice != null ? (askPrice === 0 ? 'N/A' : askPrice) : 'N/A'}</h6>
                                    )}
                                </label>
                            </div>
                            {!loading && value === 'buyPrice' && bidPrice <= 0 ? (
                                <span className="text-danger">Buy price must be greater than zero</span>
                            ) : value === 'sellPrice' && askPrice <= 0 ? (
                                <span className="text-danger">Sell price must be greater than zero</span>
                            ) : (
                                ''
                            )}
                        </div>
                        {value === 'sellPrice' && portfolioId !== '' && (
                            <div className="mt-1 text-muted text-xs">Units available for sell : {totalUnits}</div>
                        )}
                        <Form.Group>
                            <Form.Label className="pt-2 text-sm" htmlFor="units">
                                Units
                            </Form.Label>
                            <input
                                className="form-control text-sm"
                                type="number"
                                id="units"
                                aria-label="units"
                                onChange={handleUnitChange}
                                value={unit ?? ''}
                                autoFocus
                                ref={unitsRef}
                                placeholder="0"
                            />
                            <span className="text-sm">
                                {simpleValidator.current.message('Units', unit, 'required|min:1,num|max:100000000,num')}
                            </span>
                            {value === 'sellPrice' && portfolioId !== '' && totalUnits !== null && totalUnits - unit < 0 && (
                                <span className="text-danger text-sm"> You cannot sell more than available units</span>
                            )}
                            {unitError && <span className="text-danger text-sm">{unitError}</span>}
                        </Form.Group>
                        <div className="position-type mb-4" style={{ paddingBottom: '50px' }}>
                            <label className="pt-2 pb-2 text-sm">Portfolios</label>
                            <select
                                className="form-select form-select-sm text-sm"
                                aria-label="Default select example"
                                value={portfolioId}
                                onChange={handleportfolios}
                            >
                                <option value="" disabled>
                                    -Select Portfolios-
                                </option>
                                {selectPortfolios?.map((item) => (
                                    <option key={item.portfolio_id} value={item.portfolio_id}>
                                        {item.portfolio_name}
                                    </option>
                                ))}
                            </select>
                            <span className="text-sm">{simpleValidator.current.message('Portfolios', portfolioId, 'required')}</span>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundColor: '#e7ebef' }}>
                        <div className="row">
                            <div className="row-md-6 text-center ms-4">
                                <button
                                    type="button"
                                    style={{ whiteSpace: 'nowrap', fontSize: '12px' }}
                                    disabled={loading ? true : value === 'sellPrice' && totalUnits - unit < 0 ? true : false}
                                    className={`btn text-sm btn-outline-primary me-2 ${
                                        value === 'sellPrice' && totalUnits - unit < 0 ? 'text-black border-black opacity-50' : ''
                                    }`}
                                    onClick={handleSaveButton}
                                >
                                    Save Position
                                </button>
                                <button
                                    type="button"
                                    style={{ whiteSpace: 'nowrap', fontSize: '12px' }}
                                    className="btn btn-outline-danger "
                                    onClick={handleCancelButton}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            ) : (
                <div></div>
            )}
            <Modal show={showDialog} onHide={handleCloseDialog} className="">
                <Modal.Header style={{ fontSize: '16px', fontWeight: '500' }} closeButton>
                    Add portfolio{' '}
                </Modal.Header>
                <Modal.Body
                    style={{
                        height: '160px',
                        textAlign: 'center',
                        paddingTop: '35px',
                        fontSize: '20px',
                        paddingBottom: '50px',
                        fontWeight: 'nomral',
                    }}
                >
                    <div>You do not have any portfolios, please add a portfolio to continue.</div>
                    <div style={{ paddingTop: '20px' }} className="d-flex gap-2 justify-content-center">
                        <button
                            type="button"
                            style={{ width: '56px', height: '30px' }}
                            className="btn bg-shibui-btn btn-sm text-white"
                            onClick={handleAddPortfolio}
                        >
                            Yes
                        </button>
                        <button
                            type="button"
                            style={{ width: '59px', height: '30px' }}
                            className="btn btn-outline-secondary btn-sm"
                            onClick={handleCloseDialog}
                        >
                            No
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

const mapStatesToProps = ({
    bonds: { bondPositionData = {}, isBondPositionLoader = false },
    tradeBoardCast: { TradeBoardCastRightBar = {}, isTradeBoardCastRightBarLoader = false },
}: any) => {
    return { bondPositionData, isBondPositionLoader, TradeBoardCastRightBar, isTradeBoardCastRightBarLoader };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            ...bondsAction,
            ...portfolioAction,
            ...tradeBroadcastAction,
        },
        dispatch
    );
};

export default connect(mapStatesToProps, mapDispatchToProps)(BondPosition);
